module.exports = __webpack_public_path__ + "static/ashiato-62c4cccf96e17c3f01c2b6f5209685b6.png";